import React, { useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import ToggleField from 'components/ToggleField'
import BoardsToggle from 'components/BoardsToggle'
import BackButton from 'components/BackButton'
import Link from 'components/Link'

import s from './BoardsMenu.module.css'

function BoardsMenu({
  className,
  boards,
  boardType,
  site,
  currentBoard,
  boardToggled,
  handleBoardToggle,
  inTownToggled,
  toggleInTown,
  handleFollowersToggle,
}) {
  const [dropdown, setDropdown] = useState(false)

  const setBoards = (classname = '') => {
    return (
      <div className={classname}>
        {boards
          // .filter(({ slug }) => slug !== currentBoard)
          .map(({ slug, id, title }) => {
            const matchingUrl = slug === currentBoard
            return React.createElement(
              matchingUrl ? 'h1' : 'h2',
              {
                className: classNames(s.link, {
                  [s.linkActive]: matchingUrl,
                }),
                key: id,
              },
              <Link href={`${boardType}/${slug}`} type="Board">
                <span
                  dangerouslySetInnerHTML={{
                    __html:
                      title === 'All' && boards.length === 1
                        ? `${boardType
                            .charAt(0)
                            .toUpperCase()}${boardType.substring(1)}`
                        : title,
                  }}
                />
              </Link>
            )
          })}
      </div>
    )
  }

  const handleDropdown = () => {
    setDropdown(!dropdown)
  }

  return (
    <div className={className}>
      <div className={s.container}>
        <BackButton fallback={`${site}/${boardType}`} />
        {!['london', 'milano'].includes(site) && (
          <ToggleField
            className={s.inTownToggle}
            onChange={toggleInTown}
            toggled={inTownToggled}
          >
            In Town
          </ToggleField>
        )}
        <button
          type="button"
          className={classNames(s.dropdownBtn, {
            [s.dropdownBtnExpanded]: dropdown,
          })}
          onClick={handleDropdown}
        >
          {currentBoard || boardType}
        </button>
        {setBoards(s.boardsDesktop)}
        <BoardsToggle
          className={s.toggle}
          boardToggled={boardToggled}
          handleBoardToggle={handleBoardToggle}
          handleFollowersToggle={handleFollowersToggle}
          handleTownToggled={toggleInTown}
          site={site}
        />
      </div>
      {setBoards(classNames(s.boardsMobile, { [s.boardsVisible]: dropdown }))}
    </div>
  )
}

BoardsMenu.propTypes = {
  className: PropTypes.string,
  boards: PropTypes.array,
  boardType: PropTypes.string,
  site: PropTypes.string,
  currentBoard: PropTypes.string,
  boardToggled: PropTypes.bool,
  handleBoardToggle: PropTypes.func,
  inTownToggled: PropTypes.bool,
  toggleInTown: PropTypes.func,
  handleFollowersToggle: PropTypes.func,
}
BoardsMenu.defaultProps = {
  className: '',
  boards: [],
  boardType: '',
  site: '',
  currentBoard: '',
  boardToggled: false,
  handleBoardToggle: () => {},
  inTownToggled: false,
  toggleInTown: () => {},
  handleFollowersToggle: () => {},
}

export default BoardsMenu
